import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { DxDataGridComponent, DxDropDownBoxComponent } from 'devextreme-angular';
import { PictogrammeDto } from 'src/api/models';
import { DevExtremeTranslationService } from 'src/core/services/devExtremeTranslation.service';
import { PanelLayoutService } from 'src/core/services/panel-layout.service';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-pictogramme-select',
  templateUrl: './pictogramme-select.component.html',
  styleUrls: ['./pictogramme-select.component.css']
})
export class PictogrammeSelectComponent implements OnInit, OnDestroy {
  @ViewChild('dxDropDown') dropDown: DxDropDownBoxComponent;
  @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
  @Select(ControlPanelStore.pictogrammes$) pictogrammes$: Observable<PictogrammeDto[]>;

  @Input() width: number;
  @Input() widthPopUp: number = 250;
  @Input() height: number = 78;
  @Input() disabled: boolean = false;

  @Input() pictogrammeId: number;
  @Output() pictogrammeIdChange = new EventEmitter<number>();

  @Input() cell: any;

  InitId = null;

  Pictogrammes: PictogrammeDto[] = [];
  ColumnName = [];

  p: Subscription;

  constructor(private panelLayoutService: PanelLayoutService,
    private translate: TranslateService,
    private devExtremeTranslationService: DevExtremeTranslationService) {
      // Instanciate Globalize for DevExtreme components
    this.devExtremeTranslationService.loadLanguage(this.translate.getBrowserLang());

    this.translate.get(
      [
        'Nom',
        'Image',
      ]
      ).subscribe(translations => {
        this.ColumnName.push(translations['Nom']);
        this.ColumnName.push(translations['Image']);
      });
    }

  ngOnInit() {
    if(this.pictogrammeId != null) {
      this.InitId = JSON.parse(JSON.stringify(this.pictogrammeId));
    }
    this.p = this.pictogrammes$.subscribe(res => {
      if (res != null) {
        this.Pictogrammes = res;
      }
    });
  }

  ngOnDestroy() {
    this.p?.unsubscribe();
  }

  updateInfo(event) {
    this.pictogrammeId = event.currentSelectedRowKeys.length == 1 ? event.currentSelectedRowKeys[0].Id : this.pictogrammeId;
    if (!!this.cell && this.InitId != this.pictogrammeId) {
      this.cell.setValue(this.pictogrammeId);
    }
    this.pictogrammeIdChange.emit(this.pictogrammeId);

    if(this.pictogrammeId != null) {
      this.dropDown.instance.close();
    }
  }

  getHeight() {
    return { 'height': this.height+'px' };
  }

  getHeightImage() {
    return this.height;
  }

  onOpened() {
    if(this.pictogrammeId == null) {
      this.dataGrid.instance.clearSelection();
    }

    document.body.childNodes.forEach(element => {
      if(element.nodeType == 1) {
        if((element as HTMLElement).className.includes("dx-dropdowneditor-overlay")) {
          (element.childNodes[0] as HTMLElement).style.width = `${this.widthPopUp}px`;
        }
      }
    });
  }
}
